<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select class="filter-item" v-model="listQuery.querymodel.SectionIds" placeholder="请选择路段" collapse-tags
        :multiple="true" :clearable="true" @change="getList()">
        <el-option v-for="item in sectionlist" :key="item.Id" :label="item.SectionName" :value="item.Id"></el-option>
      </el-select>
      <el-select v-if="ProductId == 2" class="filter-item" v-model="listQuery.querymodel.BrandId" placeholder="请选择商户"
        collapse-tags :clearable="true" @change="getList()">
        <el-option v-for="item in brandlist" :key="item.Id" :label="item.BrandName" :value="item.Id"></el-option>
      </el-select>
      <el-select style="margin-right: 10px" :clearable="true" v-model="listQuery.querymodel.OrderState"
        placeholder="请选择订单状态" @change="getList()">
        <el-option label="全部状态" :value="-1"></el-option>
        <el-option label="在停" :value="0"></el-option>
        <el-option label="已结" :value="1"></el-option>
        <el-option label="跑单" :value="2"></el-option>
      </el-select>
      <el-select style="margin-right: 10px" :clearable="true" v-model="listQuery.querymodel.abnormaltype"
        placeholder="异常订单筛选" @change="getList()">
        <el-option label="免单" :value="1"></el-option>
        <el-option label="优惠大于0" :value="2"></el-option>
      </el-select>
      <el-select style="margin-right: 10px" :clearable="true" v-model="listQuery.querymodel.ismonth" placeholder="月卡筛选"
        @change="getList()">
        <el-option label="月卡车" :value="1"></el-option>
        <el-option label="非月卡车" :value="2"></el-option>
      </el-select>
      <el-select v-if="ProductId == 2" style="margin-right: 10px" :clearable="true"
        v-model="listQuery.querymodel.ResetInTimeMark" placeholder="重置时间筛选" @change="getList()">

        <el-option label="已重置" :value="1"></el-option>
        <el-option label="未重置" :value="0"></el-option>
      </el-select>
      <el-select v-if="ProductId == 2" style="margin-right: 10px" :clearable="true"
        v-model="listQuery.querymodel.VcardMark" placeholder="虚拟卡筛选" @change="getList()">
        <el-option label="虚拟卡" :value="1"></el-option>
        <el-option label="非虚拟卡" :value="0"></el-option>
      </el-select>
       <el-select v-if="ProductId == 2" style="margin-right: 10px" :clearable="true"
        v-model="listQuery.querymodel.AccessStatus" placeholder="车牌锁定状态" @change="getList()">

         <el-option label="全部状态" :value="-1"></el-option>
        <el-option label="不限制" :value="0"></el-option>
        <el-option label="不可出场" :value="1"></el-option>
        <el-option label="可出场" :value="2"></el-option>
          <el-option label="临时出场" :value="3"></el-option>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.querymodel.SaleUserIds" placeholder="请选择收费员/出场操作人" multiple
        filterable @change="getList()" :clearable="true">
        <el-option v-for="item in emplist" :key="item.Id" :label="item.EmpName" :value="item.Id">
        </el-option>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.querymodel.CreteUserIds" placeholder="请选择开单人" multiple
        filterable @change="getList()" :clearable="true">
        <el-option v-for="item in emplist" :key="item.Id" :label="item.EmpName" :value="item.Id">
        </el-option>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.querymodel.DateType" @change="getList()" placeholder="请选择时间类型">
        <el-option label="出场时间" :value="2"></el-option>
        <el-option label="入场时间" :value="1"></el-option>
      </el-select>
      <el-date-picker @change="datechange" :clearable="false" class="filter-item" v-model="querydate"
        type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-input class="filter-item" v-model="listQuery.querymodel.keyword" placeholder="车牌号"
        style="width: 250px;!important" @keyup.enter.native="getList()" />
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
      <el-button v-if="(listQuery.querymodel.OrderState == 1 || listQuery.querymodel.OrderState == 2) && authdelete"
        class="filter-item" type="danger" icon="el-icon-delete" @click="orderbulkdelete()">批量删除</el-button>
    </div>
    <el-table class="app-table" :data="list" border fit highlight-current-row stripe ref="orderrecordtable" show-summary
      :summary-method="getSummaries" style="width: 100%"
      :height="width > 1920 ? getViewHeight() - 46 : getViewHeight() - 46"
      :header-cell-style="{ background: '#F3F4F7', color: '#555' }" :row-style="{ height: '10px' }"
      :cell-style="{ padding: '7px 0' }" @selection-change="handleSelectionChange">
      <el-table-column v-if="(listQuery.querymodel.OrderState == 1 || listQuery.querymodel.OrderState == 2) && authdelete"
        type="selection" width="55"> </el-table-column>
      <el-table-column :min-width="210" label="操作" fixed="left" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="text" @click="detailview(row)">缴费记录
          </el-button>
          <el-button size="mini" type="text"
            v-if="autheditout && row.OrderState == 1 && row.ShouldAmount == row.OrderDiscount && row.ShouldAmount > 0"
            @click="resetorder(row)">重置为跑单
          </el-button>
          <el-button v-if="row.ImgUrl != null && row.ImgUrl != ''" size="mini" type="text"
            @click="handlePreView(row.ImgUrl)">入场图片
          </el-button>
          <el-button v-if="row.OrderState == 2 && row.AdvanceAmount == 0 && autheditout" size="mini" type="text"
            @click="caroutcmd(row)">修改
          </el-button>
          <el-button v-if="row.OrderState != 0 && row.AdvanceAmount == 0 && row.ActualAmount == 0 && authdelete"
            size="mini" type="text" @click="orderdelete(row)">删除
          </el-button>
          <el-button v-if="row.OrderState == 0 && autheditout" size="mini" type="text" @click="carincmd(row)">修改
          </el-button>
          <el-button v-if="row.OrderState == 0 && row.AdvanceAmount == 0 && authcarout" size="mini" type="text"
            @click="caroutcmd(row)">出场
          </el-button>
        </template>
      </el-table-column>
      <el-table-column type="index" width="70" label="序号"> </el-table-column>
      <el-table-column :key="index" v-for="(col, index) in columns" :label="col.label" :align="col.align"
        :prop="col.value" :type="col.type" :width="col.width"
        :formatter="col.formatter == true ? tableformatter : null">
      </el-table-column>
    </el-table>
    <!-- 确认出场 -->
    <el-dialog :visible.sync="caroutmodel.dialogshow" append-to-body :show-close="false" :width="'457px'"
      :close-on-click-modal="false">
      <el-row slot="title"><el-col :span="21" style="font-size: 18px; color: black; text-align: left">{{
        caroutmodel.data.OrderState == 0 ? '出场信息确认' : '欠费信息修改' }}</el-col>
        <el-col :span="3" style="
              color: red;
              font-size: 25px;
              cursor: pointer;
              text-align: right;
            "><i class="el-icon-close" @click="caroutmodel.dialogshow = false"></i>
        </el-col>
      </el-row>
      <div class="app-container">
        <div class="filter-container2">
          <el-form>
            <el-form-item label="车牌号码：" label-width="90px">
              {{ caroutmodel.data.LicencePlate }}
            </el-form-item>
            <el-form-item label="入场时间：" label-width="90px">
              {{ caroutmodel.data.SaleTime }}
            </el-form-item>
            <el-form-item label="出场时间：" label-width="90px">
              <el-date-picker v-model="caroutSaleEndTime" :picker-options="pickerOptionscarout" type="datetime"
                style="width: 100%" placeholder="选择日期时间" @change="carouttimechange()">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="停车时长：" label-width="90px">
              {{ caroutmodel.data.Chargeduration }}
            </el-form-item>
            <el-form-item label="停车费用：" label-width="90px">
              {{ caroutmodel.data.ShouldAmount }}
            </el-form-item>
            <el-form-item label="优惠减免：" label-width="90px">
              {{ caroutmodel.data.ShouldAmount - caroutmodel.data.ActualAmount }}
            </el-form-item>
            <el-form-item label="收款金额：" label-width="90px">
              <el-input-number style="width: 200px" @focus="inputfocus($event)" :min="0"
                :max="caroutmodel.data.ShouldAmount" v-model="caroutmodel.data.ActualAmount"
                controls-position="right"></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="caroutmodel.dialogshow = false">取 消</el-button>
        <el-button v-if="caroutmodel.data.ActualAmount > 0 && caroutmodel.data.OrderState == 0" type="primary"
          :disabled="returnloading" :loading="returnloading" @click="carcoutcommit()" style="margin-right: 10px">{{
            returnloading == false ?
              "欠费出场" : "欠费出场中" }}
        </el-button>
        <el-button v-if="caroutmodel.data.ActualAmount == 0 && caroutmodel.data.OrderState == 0" type="primary"
          :disabled="returnloading" :loading="returnloading" @click="carcoutcommit()" style="margin-right: 10px">{{
            returnloading == false ?
              "确认出场" : "确认出场中" }}
        </el-button>
        <el-button v-if="caroutmodel.data.OrderState == 2" type="primary" :disabled="returnloading"
          :loading="returnloading" @click="carcoutcommit()" style="margin-right: 10px">{{ returnloading == false ?
            "保存修改" : "保存修改中" }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 入场信息修改 -->
    <el-dialog :visible.sync="carinmodel.dialogshow" append-to-body :show-close="false" :width="'457px'"
      :close-on-click-modal="false">
      <el-row slot="title"><el-col :span="21" style="font-size: 18px; color: black; text-align: left">入场信息修改</el-col>
        <el-col :span="3" style="
              color: red;
              font-size: 25px;
              cursor: pointer;
              text-align: right;
            "><i class="el-icon-close" @click="carinmodel.dialogshow = false"></i>
        </el-col>
      </el-row>
      <div class="app-container">
        <div class="filter-container2">
          <el-form>
            <el-form-item label="车牌号码：" label-width="90px">
              <el-input v-model="carinmodel.data.LicencePlate" maxlength="10" show-word-limit autocomplete="off"
                placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="入场时间：" label-width="90px">
              <el-date-picker v-model="carinSaleEndTime" type="datetime" style="width: 100%" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="车型：" label-width="90px">
              <el-select style="width: 100%" v-model="carinmodel.data.CarType" placeholder="请选择所属车型">
                <el-option v-for="item in typelist" :key="item.id" :label="item.text" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="carinmodel.dialogshow = false">取 消</el-button>
        <el-button v-if="carinmodel.data.OrderState == 0" type="primary" :disabled="returnloading"
          :loading="returnloading" @click="carincommit()" style="margin-right: 10px">{{ returnloading == false ?
            "保存修改" : "保存修改中" }}
        </el-button>
      </div>
    </el-dialog>
    <orderpaylist v-if="dialogshow" :dialogshow="dialogshow" :OrderId="detailviewId" :authunsettle="authunsettle"
      @cancelcomplete="cancelcomplete" @savecomplete="savecomplete">
    </orderpaylist>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
      @pagination="getList" />
  </div>
</template>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 5px 0px 5px 0px !important;
}

/deep/ .el-dialog__footer {
  padding: 0px 0px !important;
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
}

/deep/ .el-dialog__header {
  padding: 10px 10px 0px !important;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

/deep/ .el-tabs__nav-wrap::after {
  background-color: white !important;
}

/deep/ .el-tabs__content {
  flex-grow: 1 !important;
}

.dialog-footer {
  height: 50px;
  margin-top: 30px;
  padding-top: 5px;
}

.xj {
  color: #606266;
  text-align: right;
  height: 24px;
  margin-top: 10px;
}

.info_title {
  background: #f5f7fa;
  color: #666;
  font-weight: 700;
  text-indent: 16px;
  line-height: 30px;
  font-size: 16px;
}

.xj font {
  color: #f56c6c;
  font: bold 22px/24px tahoma;
  margin-right: 5px;
}
</style>
<script>
import { queryemp } from "@/api/employee";
import { query as querybrand } from "@/api/brand"
import { getorderrecord, GetOrderById, CarOut, editcarin, resetorderbyid, bulkdelete } from "@/api/order";
import { query as querysectionlist } from "@/api/section";
import { MrYangUtil } from "../../utils/time.js";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
import orderpaylist from "./components/orderpaylist.vue";
export default {
  components: { Pagination, Toolbar, orderpaylist },
  directives: { waves },
  data() {
    return {
      brandlist: [],

      ProductId: 1,
      dialogshow: false,
      tabletypelist: [],
      emplist: [],
      tablelist: [],
      sectionlist: [],
      isedit: false,
      buttonList: [],
      downloadLoading: false,
      returnloading: false,
      list: [],
      pageIndex: 1,
      total: 0,
      authunsettle: false,
      autheditout: false,
      authdelete: false,
      detailviewId: "",
      orderrecordmain: {},
      typelist: [
        { id: 1, text: "小型车" },
        { id: 2, text: "中型车" },
        { id: 3, text: "大型车" },
        { id: 4, text: "新能源车" },
        { id: 5, text: "其他车型" },
      ],
      caroutM: { ActualAmount: 0.0, CarType: 1, OrderDiscount: 0.0, OrderId: "", PayAuthCode: "", PaywayId: 0, SaleEndTime: "", ScanPayMark: false, ShouldAmount: 0.0, iseditendtimemark: true, skipoutmark: false },
      caroutmodel: {
        dialogshow: false,
        data: {}
      },
      carinmodel: {
        dialogshow: false,
        data: {}
      },
      // 设置最小日期为当前日期
      pickerOptionscarout: {
        disabledDate(time) {
          return time.getTime() > new Date(this.caroutmodel.data.SaleTime).getTime()
        }
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              const start = new Date();
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              let s = MrYangUtil.getCurrentWeek()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentWeek()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              let s = MrYangUtil.getCurrentMonth()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentMonth()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              let s = MrYangUtil.getPreviousMonth()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getPreviousMonth()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "本年",
            onClick(picker) {
              let s = MrYangUtil.getCurrentYear()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentYear()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
        ],
      },
      querydate: "",
      columns: [
        { label: "车牌号", value: "LicencePlate", align: "center", width: 100 },
        { label: "车型", value: "CarTypeName", align: "center", width: 100 },
        { label: "订单号", value: "Id", align: "center", width: 180 },
        { label: "状态", value: "StateName", align: "center", width: 180 },
        {
          label: "停车路段",
          value: "SectionName",
          align: "center",
          width: 100,
        },
        { label: "泊位号", value: "ParkName", align: "center", width: 130 },
        {
          label: "驶入时间",
          value: "SaleTime",
          align: "center",
          width: 150,
        },
        {
          label: "驶离时间/跑单时间",
          value: "SaleEndTime",
          align: "center",
          width: 150,
        },
        {
          label: "停车时长",
          value: "Chargeduration",
          align: "center",
          width: 150,
        },
        {
          label: "是否月卡",
          value: "IsMonthCard",
          align: "right",
          width: 80,
        },
        {
          label: "是否免单",
          value: "IsFree",
          align: "right",
          width: 80,
        },
        {
          label: "停车费用",
          value: "ShouldAmount",
          align: "right",
          width: 80,
          formatter: true,
        },
        {
          label: "优惠减免",
          value: "OrderDiscount",
          align: "right",
          width: 80,
          formatter: true,
        },
        {
          label: "实际应收",
          value: "RealAmount",
          align: "right",
          width: 80,
          formatter: true,
        },
        {
          label: "预付收款",
          value: "AdvanceAmount",
          align: "right",
          width: 80,
          formatter: true,
        },
        {
          label: "出场收款",
          value: "ActualAmount",
          align: "right",
          width: 80,
          formatter: true,
        },
        {
          label: "欠缴金额",
          value: "Arrearage",
          align: "right",
          width: 80,
          formatter: true,
        },
        {
          label: "开单人",
          value: "EmpName",
          align: "center",
          width: 100,
        },
        {
          label: "开单时间",
          value: "CreateTime",
          align: "center",
          width: 180,
        },
        {
          label: "收费员/出场操作人",
          value: "EmpName2",
          align: "center",
          width: 180,
        },
        {
          label: "重置操作人",
          value: "EmpNameR",
          align: "center",
          width: 180,
        },
        {
          label: "联系电话",
          value: "LinkTel",
          align: "center",
          width: 100,
        },
        {
          label: "备注",
          value: "Remark",
          align: "left",
          formatter: false,
          width: 300
        },
      ],
      authcarout: false,
      caroutSaleEndTime: "",
      carinSaleEndTime: "",
      width: 1920,
      servicetime: 0,
      multipleSelection: [],
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          OrderState: -1,
          keyword: "",
          begintime: "",
          endtime: "",
          DateType: 1,
          SaleType: 1,
          BrandId: "",
          SaleUserIds: [],
          abnormaltype: "",
          ismonth: "",
          ResetInTimeMark: "",
          VcardMark: "",
          AccessStatus: ""

        },
      },
    };
  },
  created() {
    try {
      this.ProductId = window.localStorage.ProductId;
      if (this.ProductId == 2) {
        querybrand({ pageSize: 10000, }).then(res => {
          this.brandlist = res.data;
        });
      }
      let userinfo = JSON.parse(window.localStorage.getItem("user"));
      let stime = userinfo.syspara.filter((it) => it.ParaKey === "ht17")[0]
        .ParaValue;
      let ssstime = new Date(stime);
      let sstime = new Date();
      sstime.setSeconds(0);
      sstime.setHours(ssstime.getHours());
      sstime.setMinutes(ssstime.getMinutes());
      if (sstime.getTime() < new Date().getTime()) {
        this.servicetime =
          sstime.getHours() * 3600 * 1000 + sstime.getMinutes() * 60 * 1000;
      } else {
        this.servicetime = -(
          3600 * 1000 * 24 -
          (sstime.getHours() * 3600 * 1000 + sstime.getMinutes() * 60 * 1000)
        );
      }
    } catch {
      this.servicetime = 0;
    }
    this.width = document.documentElement.clientWidth;
    const end = new Date();
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);
    const start = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setTime(start.getTime() + this.servicetime);
    end.setTime(end.getTime() + this.servicetime);
    this.querydate = [start, end];
    this.listQuery.querymodel.begintime = start;
    this.listQuery.querymodel.endtime = end;
    querysectionlist({
      pageSize: 10000,
    }).then((res) => {
      this.sectionlist = res.data;
    });
    queryemp({
      pageIndex: 1,
      pageSize: 10000,
      orderColumn: "",
      orderbyasc: false,
      querymodel: {
        EnableMark: -1,
        ShopMark: -1,
        keyword: "",
        AdminMark: true,
      },
    }).then((res) => {
      this.emplist = res.data;
    });
    this.getList();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["orderrecordtable"].doLayout();
    });
  },
  methods: {
    orderdelete(row) {
      //添加删除确认框
      this.$confirm("此操作将永久删除该停车记录, 是否继续?", "提示", {
        type: 'warning'
      })
        .then(() => {
          var ids = [];
          ids.push(row.Id);
          bulkdelete(ids).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          });
        })
        .catch(() => { });
    },
    orderbulkdelete() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少选择一个停车记录！",
          type: "error",
        });
        return;
      }
      //添加删除确认框
      this.$confirm("此操作将永久删除这些停车记录, 是否继续?", "提示", {
        type: 'warning'
      })
        .then(() => {

          var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.Id);
          });
          bulkdelete(ids).then((res) => {
            this.$message({
              message: "批量操作成功",
              type: "success",
            });
            this.getList();
          });
        })
        .catch(() => { });

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getcarouttime(time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      h = h < 10 ? '0' + h : h
      var minute = date.getMinutes()
      minute = minute < 10 ? '0' + minute : minute
      var s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
    },
    carouttimechange() {
      var changemodel = { OrderId: this.caroutmodel.data.Id, endTime: this.getcarouttime(this.caroutSaleEndTime), CarType: this.caroutmodel.data.CarType, isedit: true }
      GetOrderById(changemodel).then(res => {
        this.caroutmodel.data = res;
        this.caroutmodel.data.ActualAmount = this.caroutmodel.data.ShouldAmount;
      })
    },
    caroutcmd(row) {
      var that = this;
      GetOrderById({ OrderId: row.Id, CarType: row.CarType }).then(res => {
        that.caroutmodel.data = res;
        if (row.OrderState == 0) {
          that.caroutmodel.data.ActualAmount = this.caroutmodel.data.ShouldAmount;
        }
        if (row.OrderState == 2) {
          that.caroutmodel.data.ActualAmount = res.ArrearageAmount;
        }
        that.caroutSaleEndTime = this.caroutmodel.data.SaleEndTime;
        that.pickerOptionscarout = {
          disabledDate(time) {
            return time.getTime() < new Date(that.caroutmodel.data.SaleTime).getTime()
          }
        },
          that.caroutmodel.dialogshow = true;
      })
    },
    carincmd(row) {
      var that = this;
      that.carinmodel.data = row;
      that.carinmodel.dialogshow = true;
      that.carinSaleEndTime = this.carinmodel.data.SaleTime;

    },
    carcoutcommit() {
      this.caroutmodel.OrderId = this.caroutmodel.data.Id;
      this.caroutM.OrderId = this.caroutmodel.data.Id;
      this.caroutM.ActualAmount = 0;
      this.caroutM.ShouldAmount = this.caroutmodel.data.ShouldAmount;
      this.caroutM.CarType = this.caroutmodel.data.CarType;
      this.caroutM.SaleEndTime = this.caroutmodel.data.SaleEndTime;
      this.caroutM.iseditendtimemark = false;
      this.caroutM.skipoutmark = this.caroutmodel.data.ActualAmount > 0;
      this.caroutM.OrderDiscount = this.caroutmodel.data.ShouldAmount - this.caroutmodel.data.ActualAmount;
      this.caroutM.iseditendtimemark = true;
      // { ActualAmount: 0.0, CarType: 1, OrderDiscount: 0.0, OrderId: "", PayAuthCode: "", PaywayId: 0, SaleEndTime: "", ScanPayMark: false, ShouldAmount: 0.0, iseditendtimemark: true, skipoutmark: false }
      CarOut(this.caroutM).then(res => {
        this.$message({
          message: "操作成功！",
          type: "success",
        });
        this.caroutmodel.dialogshow = false;
        this.getList()
      })
    },
    carincommit() {
      this.carinmodel.data.SaleTime = this.carinSaleEndTime;
      editcarin(this.carinmodel.data).then(res => {
        this.$message({
          message: "操作成功！",
          type: "success",
        });
        this.carinmodel.dialogshow = false;
        this.getList()
      })

    },
    handlePreView(ImgUrl) {
      let str = "https://tc.mtfpos.com" + ImgUrl;
      window.open(str, '_blank')
    },
    tableformatter(row, column, cellValue) {
      switch (column.property) {
        case "ShouldAmount":
        case "OrderDiscount":
        case "ActualAmount":
        case "AdvanceAmount":
        case "AdvanceRefund":
        case "Arrearage":
        case "RealAmount":
          return Number(cellValue).toFixed(2);
      }
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "总计：";
          return;
        }
        if (this.orderrecordmain[column.property] != undefined) {
          sums[index] = Number(this.orderrecordmain[column.property]).toFixed(
            2
          );
        }
      });
      return sums;
    },
    datechange(item) {
      if (item.length === 3) {
        this.querydate = [item[0], item[1]];
        this.querydate[0].setTime(
          this.querydate[0].getTime() + this.servicetime
        );
        this.querydate[1].setTime(
          this.querydate[1].getTime() + this.servicetime
        );
      }
      this.listQuery.querymodel.begintime = this.querydate[0];
      this.listQuery.querymodel.endtime = this.querydate[1];
      this.getList();
    },
    callFunction(item) {
      this[item.BtnCode].apply(this, item);
    },
    savecomplete() {
      this.dialogshow = false;
      this.getList();
    },
    cancelcomplete() {
      this.dialogshow = false;
    },
    detailview(row) {
      this.dialogshow = true;
      this.detailviewId = row.Id;
    },
    resetorder(row) {
      this.$confirm('此操作将把订单重置为跑单欠费状态，确定重置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetorderbyid({ Id: row.Id }).then((res) => {
          this.$message({
            message: '重置成功！',
            type: 'success'
          })
          this.getList()
        })
      }).catch(() => {

      });
    },
    getList(item) {
      if (item != null && item != undefined) {
        this.listQuery.pageIndex = item.page;
        this.listQuery.pageSize = item.limit;
      } else {
        this.listQuery.pageIndex = 1;
      }
      getorderrecord(this.listQuery).then((res) => {
        this.orderrecordmain = res.maindata;
        this.list = res.data;
        this.total = res.dataCount;
      });
    },
    m_export() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = [];
        const filterVal = [];
        this.columns.forEach((item) => {
          tHeader.push(item.label);
          filterVal.push(item.value);
        });
        const exportquery = JSON.parse(JSON.stringify(this.listQuery));
        let index = 1;
        exportquery.pageIndex = 1;
        exportquery.pageSize = 1000000;
        exportquery.mergeSize = false;
        getorderrecord(exportquery).then((res) => {
          const orderrecordmain = res.maindata;
          orderrecordmain.LicencePlate = "总计：";
          res.data.push(orderrecordmain);
          const data = res.data.map((v) =>
            filterVal.map((j) => {
              if (j === "index") {
                return index++;
              } else {
                return v[j];
              }
            })
          );
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "停车记录",
          });
          this.downloadLoading = false;
        });
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.buttonList.forEach((item) => {
      if (item.BtnCode === "unsettle") {
        this.authunsettle = true;
      }
      if (item.BtnCode === "carout") {
        this.authcarout = true;
      }
      if (item.BtnCode === "editout") {
        this.autheditout = true;
      }
      if (item.BtnCode === "delete") {
        this.authdelete = true;
      }

    });
  },
};
</script>